import FooterIconButton from "@components/buttons/contact/FooterIconButton"
import { useRouter } from "next/router"
import { useTranslations } from "next-intl"
import { BsTelephone } from "react-icons/bs"

const CallUsButton = () => {
  const t = useTranslations("nav")
  const router = useRouter()
  const { asPath } = router
  const phoneNumber =
    asPath === "/lp/linkedin"
      ? "971506004244"
      : asPath.startsWith("/lp/")
        ? "971507106247"
        : process.env.NEXT_PUBLIC_WHATSAPP_NUMBER

  return (
    <FooterIconButton
      colorScheme={"blue"}
      right={5}
      icon={<BsTelephone />}
      aria-label={t("call_us")}
      animateX={[100, -35, 0]}
      onClick={() => {
        window.open(`tel:+${phoneNumber}`, "_blank")
      }}
    />
  )
}

export default CallUsButton
